import { Controller } from "@hotwired/stimulus"

// The Sending screen: while a blast is running, poll the send's counts and
// paint "Sent 212 of 412"; when it finishes, pauses or stops, reload once so
// the server renders the report. She can close the tab; the jobs keep going.
export default class extends Controller {
  static targets = ["sent", "remaining", "failed", "bar"]
  static values = { url: String, status: String, interval: { type: Number, default: 4000 } }

  connect() {
    if (this.statusValue !== "sending") return
    this.timer = setInterval(() => this.poll(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  async poll() {
    try {
      const res = await fetch(this.urlValue, { headers: { Accept: "application/json" }, credentials: "same-origin" })
      if (!res.ok) return
      const c = await res.json()
      if (this.hasSentTarget) this.sentTarget.textContent = c.sent
      if (this.hasRemainingTarget) this.remainingTarget.textContent = c.remaining
      if (this.hasFailedTarget) this.failedTarget.textContent = c.failed
      // Everyone who is no longer waiting, not sent plus failed: a bounced
      // row is neither, so adding the two up stalls the bar short of full
      // (the same bug the server-rendered bar carried).
      if (this.hasBarTarget && c.total > 0) this.barTarget.style.width = `${Math.round(((c.total - c.remaining) / c.total) * 100)}%`
      if (c.status !== "sending") {
        clearInterval(this.timer)
        window.location.reload()
      }
    } catch (e) {
      // A missed poll is nothing; the next one catches up.
    }
  }
}
